import React, { useEffect, useState } from 'react';
import { Table, Container as ContainerSuite } from 'rsuite';
import { moeda } from '../../../components/funcoes';
import { Container, ContainerInfo } from '../styles';

export default function ImprimirRelatorioVenda() {
  const [registros, setRegistros] = useState({
    vendas: [],
    qtdVendida: 0 });

  const { Column, HeaderCell, Cell } = Table;
  
  useEffect(() => {
    const registrosJson = JSON.parse(localStorage.getItem('relatorio'));
    if(registrosJson){
      setRegistros(registrosJson);
    }
  },[]);

  return (
    <ContainerSuite style={{ padding: '10px' }}>
      <Container
        style={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ContainerInfo>
          <h3>Relatório de Vendas</h3>
        </ContainerInfo>
      </Container>
      <Container>
        <ContainerInfo>
          <text>Total de vendas: {registros.qtdVendida}</text>
        </ContainerInfo>
        <ContainerInfo>
          <text>Valor total de vendas: {moeda(registros.total)}</text>
        </ContainerInfo>
      </Container>
      <Table height={600} data={registros.vendas} bordered={true}>
        <Column flexGrow={1} fixed>
          <HeaderCell>IdProduto</HeaderCell>
          <Cell dataKey="IdProduto" />
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>Descrição</HeaderCell>
          <Cell dataKey="Descricao" />
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>Qtd. Vendida</HeaderCell>
          <Cell>{(rowData) => <text>{+(rowData.QuantidadeVendida)}</text>}</Cell>
        </Column>

        <Column>
          <HeaderCell>Valor</HeaderCell>
          <Cell>{(rowData) => <text>{moeda(rowData.Valor)}</text>}</Cell>
        </Column>
      </Table>
    </ContainerSuite>
  );
}
